function ebTemplateToggleTOC() {
  const tocList = document.querySelector('.eb-template-toc-list');
  tocList.style.display = tocList.style.display === 'none' ? 'block' : 'none';
}
  document.addEventListener("DOMContentLoaded", function () {
    const tocToggleBtn = document.querySelector('.eb-template-toc-toggle');

    if (tocToggleBtn && !tocToggleBtn.getAttribute('onclick')) {
      tocToggleBtn.setAttribute('onclick', 'ebTemplateToggleTOC()');
    }
  });

/* mossriver-funnel-instrument-v4: three high-intent article -> PDP paths */
(function () {
  "use strict";
  const CAMPAIGNS = {
    "exp_20260808_article_pdp": "mossriver-exp-20260808-article-pdp",
    "mossriver_2026_order_landing": "mossriver-exp-20260808-article-pdp",
    "mossriver_newborn_starter_pack": "mossriver-newborn-starter-pack",
    "mossriver_2026_halloween_family": "mossriver-2026-halloween-family",
    "mossriver_2026_christmas_family": "mossriver-2026-christmas-family",
    // seo48h / v4_discovery surface CTAs feed the same article→PDP SEO experiment
    "mossriver_2026_seo48h": "mossriver-exp-20260808-article-pdp",
    "mossriver_2026_v4_discovery": "mossriver-exp-20260808-article-pdp"
  };
  function trackArticlePathClick(event) {
    const link = event.target.closest('a[href*="utm_campaign="],a[href*="moss_campaign="]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    const campaign = url.searchParams.get("moss_campaign") || url.searchParams.get("utm_campaign");
    const funnelId = campaign && CAMPAIGNS[campaign];
    if (!funnelId) return;
    const source = url.searchParams.get("moss_source") || url.searchParams.get("utm_source") || "unknown";
    const content = url.searchParams.get("moss_content") || url.searchParams.get("utm_content") || "";
    let savedContext = {};
    try { savedContext = JSON.parse(sessionStorage.getItem("mossriver_funnel_context") || "{}"); } catch (e) {}
    const pageQuery = new URLSearchParams(window.location.search);
    const runId = url.searchParams.get("moss_measurement_run_id") || url.searchParams.get("measurement_run_id") || pageQuery.get("moss_measurement_run_id") || pageQuery.get("measurement_run_id") || savedContext.run_id || "";
    if (url.origin === window.location.origin && url.searchParams.has("utm_campaign")) {
      url.searchParams.set("moss_source", source);
      url.searchParams.set("moss_campaign", campaign);
      if (content) url.searchParams.set("moss_content", content);
      if (runId) url.searchParams.set("moss_measurement_run_id", runId);
      ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach((key) => url.searchParams.delete(key));
      link.href = url.toString();
    }
    const sampleClass = /^(codex_|mossriver_internal_)/i.test(source) ? "internal_qa" : "external_candidate";
    if (link.dataset.mossriverTracked === "1") return;
    link.dataset.mossriverTracked = "1";
    const payload = {
      event: "mossriver_article_pdp_click",
      mossriver_funnel_id: funnelId,
      destination_path: url.pathname,
      link_text: (link.textContent || "").trim(),
      campaign: campaign,
      content: content,
      moss_measurement_run_id: runId,
      moss_experiment_id: funnelId,
      moss_event_id: (runId || "live") + ":article_pdp_click:" + Date.now() + ":" + Math.random().toString(36).slice(2, 8),
      moss_sample_class: sampleClass
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.gtag === "function") {
      // Do not force transport_type:beacon — plain gtag library transport
      // matches the landed moss_map shape (2026-09-29 wire-table lesson).
      window.gtag("event", "article_pdp_click", {
        funnel_id: payload.mossriver_funnel_id,
        destination_path: payload.destination_path,
        moss_source: source,
        campaign: payload.campaign,
        content: payload.content,
        moss_measurement_run_id: payload.moss_measurement_run_id,
        moss_experiment_id: payload.moss_experiment_id,
        moss_event_id: payload.moss_event_id,
        moss_sample_class: payload.moss_sample_class
      });
    }
  }
  document.addEventListener("click", trackArticlePathClick, false);
}());
